import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
// import timezone from "dayjs/plugin/timezone"

dayjs.extend(utc)
// dayjs.extend(timezone)
// dayjs.tz.setDefault("Australia/Sydney")

export const dateFormat = (date: Date | string, format: string = "MMMM D, YYYY") => {
  return dayjs(date).format(format)
}
